import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M14.183 16.798C15.669 14.693 17 12.166 17 10a5 5 0 0 0-10 0c0 2.166 1.331 4.693 2.817 6.798A31 31 0 0 0 12 19.535l.186-.21c.546-.622 1.273-1.5 1.997-2.527m-1.499 3.472C14.258 18.52 18 13.949 18 10a6 6 0 0 0-12 0c0 3.949 3.742 8.521 5.316 10.27.419.465.684.73.684.73s.265-.265.684-.73",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }